import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "The3DIca"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 10.5H7.5C6.67157 10.5 6 9.82843 6 9V3C5.99968 2.60022 6.15897 2.21685 6.4425 1.935C6.75956 1.71554 7.12029 1.56716 7.5 1.5H11.25V3H7.5V9H11.25V10.5ZM3 4.5H4.5V10.5H3V4.5ZM3 1.5H4.5V3H3V1.5ZM20.5875 14.3325L16.0875 12.0825C15.8752 11.9756 15.6248 11.9756 15.4125 12.0825L10.9125 14.3325C10.6603 14.4596 10.5009 14.7176 10.5 15V20.25C10.5009 20.5324 10.6603 20.7904 10.9125 20.9175L15.4125 23.1675C15.6248 23.2745 15.8752 23.2745 16.0875 23.1675L20.5875 20.9175C20.8397 20.7904 20.9991 20.5324 21 20.25V15C20.9991 14.7176 20.8397 14.4596 20.5875 14.3325ZM15.7499 13.5825L18.5699 15L15.7499 16.41L12.9299 15L15.7499 13.5825ZM12 16.2075L15 17.7075V21.2775L12 19.7775V16.2075ZM16.5 21.2775V17.715L19.5 16.215V19.785L16.5 21.2775ZM17.25 1.5H14.25C13.4216 1.5 12.75 2.17157 12.75 3V10.5H14.25V7.5H17.25V10.5H18.75V3C18.75 2.17157 18.0784 1.5 17.25 1.5ZM14.25 6V3H17.25V6H14.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/The3DIca.vue"]]);
